import { ReferentielDTO } from './../../../shared/dtos/referentielDTO';
import { SimpleQueryResponse } from './../../../shared/dtos/simpleQueryResponse';
import { ModalAddTvaComponent } from './../../../shared/components/modals/modal-add-tva/modal-add-tva.component';
import { TvaService } from './../../../shared/services/simple/tva.service';
import { LegacyPageEvent as PageEvent, MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { TvaModel } from './../../../shared/models/simple-types/tva.model';
import { ModalInfoOkComponent } from 'src/app/shared/components/modals/info-ok/modal-info-ok.component';
import { GestionReferentielComponentService } from '../gestion-referentiel-component.service';
import { Component, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';

@Component({
  selector: 'app-gestion-tva',
  templateUrl: './gestion-tva.component.html',
  styleUrls: ['./gestion-tva.component.scss']
})
export class GestionTvaComponent implements OnInit {


  tvas: TvaModel[] = [];
  displayedColumns: string[] = ['code', 'libelle', 'taux', 'autoIntra','compteOd1', 'compteOd2', 'compteFact1', 'compteFact2', 'compteCompta', 'compteCompta2',  'action'];
  dataSource: TvaModel[];
  matDataSource = new MatTableDataSource<TvaModel>();
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageSize = 25;
  pageEvent: PageEvent;
  result: boolean;
  objet: SimpleQueryUser = new SimpleQueryUser();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdated = new EventEmitter<boolean>();

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private toastrService: ToastrService,
    private tvaService: TvaService,
    private gestionReferentielComponent: GestionReferentielComponentService) { }

  ngOnInit(): void {
    this.objet.query = '';
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.objet.order = 'libelle';
    this.matDataSource.paginator = this.paginator;
    this.loadPage();
  }

  onCreate(): void {
    const form = this.gestionReferentielComponent.getCreateTvaFormGroup();
    const dialogRef = this.dialog.open(ModalAddTvaComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          form,
          tvas: this.tvas,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.loadPage();
        }
      });

  }

  onModify(tva: TvaModel): void {
    const form = this.gestionReferentielComponent.getEditTvaFormGroup(tva);
    const dialogRef = this.dialog.open(ModalAddTvaComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          form,
          tvas: this.tvas,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.loadPage();
        }
      });
  }


  onDelete(tva: TvaModel): void {
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Suppression de la tva',
        message: 'Êtes-vous sur de vouloir supprimer la tva ?',
        icone: 'warning_amber',
        iconColor: 'accent',
        color: 'accent'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.tvaService.delete(tva.id).subscribe((response: TvaModel) => {
          this.toastrService.success('La tva a bien été supprimée');
          this.loadPage();
        });
      }
    });
  }


  orderUsers(tvas: TvaModel[]): TvaModel[] {
    tvas = tvas.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -1;
      }
    });
    return tvas;
  }

  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    const referentiel = new ReferentielDTO();
    referentiel.objet = this.objet;
    this.tvaService.loadFromSimpleQueryAdmin(referentiel).subscribe((query: SimpleQueryResponse<TvaModel>) => {
      if (query.objets != null) {
        this.tvas = query.objets;
      } else {
        this.tvas = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<TvaModel>(this.tvas);
      this.paginator.length = this.length;
    });
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }
}

